import { render, staticRenderFns } from "./input-radio.vue?vue&type=template&id=6d229894"
import script from "./input-radio.vue?vue&type=script&lang=js"
export * from "./input-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports